import React from 'react';
import {AutoComplete, Space} from 'antd';
import ConfigurableEntityIcon, {configurableIconSelectOptions} from './ConfigurableEntityIcon';

export default function ConfigurableEntityIconInput({value, onChange, ...props}) {
    return <Space.Compact style={{width: '100%'}}>
        <AutoComplete {...props} value={value} onChange={onChange} allowClear
            style={{flex: 1}} options={configurableIconSelectOptions()}
            placeholder="Choose an icon or type an emoji"
            filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}/>
        <span aria-label="Selected icon" style={{padding: '4px 12px'}}><ConfigurableEntityIcon icon={value} kind="text_asset"/></span>
    </Space.Compact>;
}
